export const module = {
  info: {
    name: 'side-nav',
    caption: 'Sidenav',
  },
  vuexModules: ['state'],
  noRoutes: true
}

export default module
